import React, { useContext, useState } from "react";
import { FluentButton } from "../../../../components/FluentUI/Fluent-Button";
import success from "../../../../assets/img/success.svg";
import PropTypes from 'prop-types';
import DownloadFormModal from "./download-form-modal";
import { LoginContext } from "../../../../services/api/authentication-api";

export default function TaskFormComplete({ isSaved, FormData }) {

  const [formId, setFormId] = useState(null);
  const handleBack = () => {
    window.history.back();
  }

  const onContinueEditing = () => {
    window.location.href = `/tasks/${FormData.TaskId}/form/${FormData.Id}`;
  }
  const user = useContext(LoginContext);

  return (
    isSaved ?
      <>
        <div className="d-flex flex-column justify-content-center align-items-center task-completed my-5">
          <img className="task-completed-picture" src={success} alt={"success"} />
          <div className="task-completed-success-text">Saved!</div>
          <div className="task-completed-success-submitted">
            Your response was saved.
          </div>
          <div className="d-flex">
            <FluentButton
              onClick={() => onContinueEditing()}
              text={"Continue editing the Form"}
              backgroundColor={"#0F6CBD"}
            />
            <div className="task-completed-button" onClick={() => handleBack()}>
              <FluentButton
                appearance="primary"
                text={"Back to Task"}
                backgroundColor={"#0F6CBD"}
              />
            </div>
          </div>
        </div>
      </>
      :
      <div className="d-flex flex-column justify-content-center align-items-center task-completed my-5">
        <img className="task-completed-picture" src={success} alt={"success"} />
        <div className="task-completed-success-text">Success!</div>
        <div className="task-completed-success-submitted">
          Your response was submitted.
        </div>
        <div className="d-flex">
          <div className="task-completed-button">
            <FluentButton
              onClick={() =>
                setFormId({ Id: FormData.Id, Name: FormData.Label })
              }
              appearance="primary"
              text={"Download my response"}
              backgroundColor={"#0F6CBD"}
            />
          </div>
        </div>
        {formId !== null && (
          <DownloadFormModal
            formId={formId}
            setFormId={setFormId}
            taskId={FormData.TaskId}
            valueName={FormData.Task?.Name}
            userName={user?.currentUser?.profile?.userNameFull}
          />
        )}
      </div>
  );
}

TaskFormComplete.propTypes = {
  isSaved: PropTypes.bool.isRequired,
  FormData: PropTypes.object.isRequired,
};